const DIRECTION_VERTICAL = 'DIRECTION_VERTICAL';
export default DIRECTION_VERTICAL;